import { EquipmentType } from '@racepointenergy/swc/scs/features/host-equipment'
import { equipmentTypes } from '../../consts'
import { EquipmentComponentProps } from '../../types'
import RedStatus from './RedStatus'
import StatusCard from './StatusCard'

const equipmentStatusComponents = {
  [equipmentTypes[EquipmentType.Components]]: ComponentsStatus,
  [equipmentTypes[EquipmentType.Chassis]]: ChassisStatus,
  [equipmentTypes[EquipmentType.UncontrollableComponents]]: () => null, // always disconnected
  [equipmentTypes[EquipmentType.MobileDevices]]: () => null, // not yet supported
  [equipmentTypes[EquipmentType.Hosts]]: () => null, // always disconnected
}

function EquipmentStatus({ equipment }: EquipmentComponentProps) {
  const { [equipment?.StatusPathParts?.type || '']: EquipmentComponent } =
    equipmentStatusComponents

  if (EquipmentComponent) {
    return <EquipmentComponent equipment={equipment} />
  }

  return null
}

function ChassisStatus({ equipment }: EquipmentComponentProps) {
  if (equipment?.ConnectedtoChassis) {
    return (
      <StatusCard
        statusNumber={equipment?.Status}
        statusString={equipment?.StatusString}
      />
    )
  }

  return <RedStatus statusString={equipment?.StatusString} />
}

function ComponentsStatus({ equipment }: EquipmentComponentProps) {
  return (
    <StatusCard
      statusNumber={equipment?.Status}
      statusString={equipment?.StatusString}
    />
  )
}

export default EquipmentStatus
